import { render, staticRenderFns } from "./TaskMailDialog.vue?vue&type=template&id=0442dd0f"
import script from "./TaskMailDialog.vue?vue&type=script&lang=js"
export * from "./TaskMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports